module.exports = __webpack_public_path__ + "static/media/papers.c6b8b3e4.jpg";